import { render, staticRenderFns } from "./BtnExcluirPrestacaoContasFinalLancamento.vue?vue&type=template&id=6813c9c9"
import script from "./BtnExcluirPrestacaoContasFinalLancamento.vue?vue&type=script&lang=js"
export * from "./BtnExcluirPrestacaoContasFinalLancamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports